import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Lightbox from '../components/Lightbox';

const BASE_URL = "https://assets.auxodev.dk/assets/c6ea7980-b639-49a1-80cc-f044c1665109";

const BILLEDER_PER_AAR = {
  '2026': [],
  '2025': [
    `${BASE_URL}/dreamfour-9995.jpg`,
    `${BASE_URL}/dreamfour-9976.jpg`,
    `${BASE_URL}/dreamfour-9903.jpg`,
    `${BASE_URL}/dreamfour-9894.jpg`,
    `${BASE_URL}/dreamfour-9883.jpg`,
    `${BASE_URL}/dreamfour-9824.jpg`,
    `${BASE_URL}/dreamfour-9804.jpg`,
    `${BASE_URL}/dreamfour-9803.jpg`,
    `${BASE_URL}/dreamfour-9797.jpg`,
    `${BASE_URL}/dreamfour-9795.jpg`,
    `${BASE_URL}/dreamfour-7656.jpg`,
    `${BASE_URL}/dreamfour-7645.jpg`,
    `${BASE_URL}/dreamfour-7640.jpg`,
    `${BASE_URL}/dreamfour-7594.jpg`,
    `${BASE_URL}/dreamfour-7447.jpg`,
    `${BASE_URL}/dreamfour-7445.jpg`,
    `${BASE_URL}/dreamfour-7418.jpg`,
    `${BASE_URL}/dreamfour-7410.jpg`,
    `${BASE_URL}/dreamfour-7405.jpg`,
    `${BASE_URL}/dreamfour-7396.jpg`,
    `${BASE_URL}/dreamfour-7373.jpg`,
    `${BASE_URL}/dreamfour-7357.jpg`,
    `${BASE_URL}/dreamfour-7352.jpg`,
    `${BASE_URL}/dreamfour-7341.jpg`,
    `${BASE_URL}/dreamfour-7300.jpg`,
    `${BASE_URL}/dreamfour-7285.jpg`,
    `${BASE_URL}/dreamfour-7261.jpg`,
    `${BASE_URL}/dreamfour-7212.jpg`
  ],
  '2024': [
    `${BASE_URL}/dreamfour-6990.jpg`,
    `${BASE_URL}/dreamfour-6989.jpg`,
    `${BASE_URL}/dreamfour-6987.jpg`,
    `${BASE_URL}/dreamfour-6974.jpg`,
    `${BASE_URL}/dreamfour-6971.jpg`,
    `${BASE_URL}/dreamfour-6967.jpg`,
    `${BASE_URL}/dreamfour-6958.jpg`,
    `${BASE_URL}/dreamfour-6955.jpg`,
    `${BASE_URL}/dreamfour-6949.jpg`,
    `${BASE_URL}/dreamfour-6907.jpg`,
    `${BASE_URL}/dreamfour-6876.jpg`,
    `${BASE_URL}/dreamfour-6853.jpg`,
    `${BASE_URL}/dreamfour-6847.jpg`,
    `${BASE_URL}/dreamfour-6839.jpg`,
    `${BASE_URL}/dreamfour-6824.jpg`,
    `${BASE_URL}/dreamfour-6811.jpg`,
    `${BASE_URL}/dreamfour-6807.jpg`,
    `${BASE_URL}/dreamfour-6802.jpg`,
    `${BASE_URL}/dreamfour-6801.jpg`,
    `${BASE_URL}/dreamfour-6799.jpg`,
    `${BASE_URL}/dreamfour-6793.jpg`,
    `${BASE_URL}/dreamfour-6790.jpg`,
    `${BASE_URL}/dreamfour-6763.jpg`,
    `${BASE_URL}/dreamfour-6759.jpg`,
    `${BASE_URL}/dreamfour-6754.jpg`,
    `${BASE_URL}/dreamfour-6745.jpg`,
    `${BASE_URL}/dreamfour-6743.jpg`,
    `${BASE_URL}/dreamfour-6738.jpg`
  ],
  '2023': [
    `${BASE_URL}/dreamfour-6714.jpg`,
    `${BASE_URL}/dreamfour-6674.jpg`,
    `${BASE_URL}/dreamfour-6659.jpg`,
    `${BASE_URL}/dreamfour-6649.jpg`,
    `${BASE_URL}/dreamfour-6641.jpg`,
    `${BASE_URL}/dreamfour-6635.jpg`,
    `${BASE_URL}/dreamfour-6629.jpg`,
    `${BASE_URL}/dreamfour-6621.jpg`,
    `${BASE_URL}/dreamfour-6618.jpg`,
    `${BASE_URL}/dreamfour-6615.jpg`,
    `${BASE_URL}/dreamfour-6576.jpg`,
    `${BASE_URL}/dreamfour-6562.jpg`,
    `${BASE_URL}/dreamfour-6557.jpg`,
    `${BASE_URL}/dreamfour-6550.jpg`,
    `${BASE_URL}/dreamfour-6478.jpg`,
    `${BASE_URL}/dreamfour-6456.jpg`,
    `${BASE_URL}/dreamfour-6451.jpg`,
    `${BASE_URL}/dreamfour-6448.jpg`,
    `${BASE_URL}/dreamfour-6443.jpg`,
    `${BASE_URL}/dreamfour-6436.jpg`,
    `${BASE_URL}/dreamfour-6409.jpg`,
    `${BASE_URL}/dreamfour-6394.jpg`,
    `${BASE_URL}/dreamfour-6379.jpg`,
    `${BASE_URL}/dreamfour-6374.jpg`
  ],
  '2022': [
    `${BASE_URL}/dreamfour-6372.jpg`,
    `${BASE_URL}/dreamfour-6352.jpg`,
    `${BASE_URL}/dreamfour-6331.jpg`,
    `${BASE_URL}/dreamfour-6319.jpg`,
    `${BASE_URL}/dreamfour-6280.jpg`,
    `${BASE_URL}/dreamfour-6278.jpg`,
    `${BASE_URL}/dreamfour-6272.jpg`,
    `${BASE_URL}/dreamfour-6268.jpg`,
    `${BASE_URL}/dreamfour-6260.jpg`,
    `${BASE_URL}/dreamfour-6237.jpg`,
    `${BASE_URL}/dreamfour-6185.jpg`,
    `${BASE_URL}/dreamfour-6168.jpg`,
    `${BASE_URL}/dreamfour-6160.jpg`,
    `${BASE_URL}/dreamfour-6138.jpg`,
    `${BASE_URL}/dreamfour-6127.jpg`,
    `${BASE_URL}/dreamfour-6120.jpg`,
    `${BASE_URL}/dreamfour-6046.jpg`,
    `${BASE_URL}/dreamfour-6033.jpg`,
    `${BASE_URL}/dreamfour-6025.jpg`,
    `${BASE_URL}/dreamfour-6021.jpg`,
    `${BASE_URL}/dreamfour-6018.jpg`,
    `${BASE_URL}/dreamfour-6003.jpg`
  ],
  '2021': [
    `${BASE_URL}/dreamfour-5992.jpg`,
    `${BASE_URL}/dreamfour-5983.jpg`,
    `${BASE_URL}/dreamfour-5956.jpg`,
    `${BASE_URL}/dreamfour-5901.jpg`,
    `${BASE_URL}/dreamfour-5877.jpg`,
    `${BASE_URL}/dreamfour-5869.jpg`,
    `${BASE_URL}/dreamfour-5856.jpg`,
    `${BASE_URL}/dreamfour-5817.jpg`,
    `${BASE_URL}/dreamfour-5814.jpg`,
    `${BASE_URL}/dreamfour-5770.jpg`,
    `${BASE_URL}/dreamfour-5762.jpg`,
    `${BASE_URL}/dreamfour-5761.jpg`,
    `${BASE_URL}/dreamfour-5727.jpg`,
    `${BASE_URL}/dreamfour-5681.jpg`,
    `${BASE_URL}/dreamfour-5672.jpg`,
    `${BASE_URL}/dreamfour-5665.jpg`,
    `${BASE_URL}/dreamfour-5664.jpg`,
    `${BASE_URL}/dreamfour-5636.jpg`,
    `${BASE_URL}/dreamfour-5626.jpg`,
    `${BASE_URL}/dreamfour-5604.jpg`,
    `${BASE_URL}/dreamfour-5592.jpg`,
    `${BASE_URL}/dreamfour-5581.jpg`,
    `${BASE_URL}/dreamfour-5573.jpg`,
    `${BASE_URL}/dreamfour-5533.jpg`
  ],
  '2020': [
    `${BASE_URL}/dreamfour-1000.jpg`,
    `${BASE_URL}/dreamfour-0988.jpg`,
    `${BASE_URL}/dreamfour-0980.jpg`,
    `${BASE_URL}/dreamfour-0956.jpg`,
    `${BASE_URL}/dreamfour-0953.jpg`,
    `${BASE_URL}/dreamfour-0928.jpg`,
    `${BASE_URL}/dreamfour-0893.jpg`,
    `${BASE_URL}/dreamfour-0881.jpg`,
    `${BASE_URL}/dreamfour-0878.jpg`,
    `${BASE_URL}/dreamfour-0876.jpg`,
    `${BASE_URL}/dreamfour-0870.jpg`,
    `${BASE_URL}/dreamfour-0811.jpg`,
    `${BASE_URL}/dreamfour-0800.jpg`,
    `${BASE_URL}/dreamfour-0758.jpg`,
    `${BASE_URL}/dreamfour-0756.jpg`,
    `${BASE_URL}/dreamfour-0740.jpg`,
    `${BASE_URL}/dreamfour-0715.jpg`,
    `${BASE_URL}/dreamfour-0713.jpg`,
    `${BASE_URL}/dreamfour-0707.jpg`,
    `${BASE_URL}/dreamfour-0617.jpg`,
    `${BASE_URL}/dreamfour-0598.jpg`,
    `${BASE_URL}/dreamfour-0546.jpg`,
    `${BASE_URL}/dreamfour-0543.jpg`,
    `${BASE_URL}/dreamfour-0528.jpg`
  ]
};

export default function Fotoarkiv() {
  const [selectedYear, setSelectedYear] = useState('2025');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const aargange = ['2026', '2025', '2024', '2023', '2022', '2021', '2020'];

  const billeder = BILLEDER_PER_AAR[selectedYear] || BILLEDER_PER_AAR['2025'];
  const erDreamFourAar = ['2024', '2025', '2026'].includes(selectedYear);

  function openImage(index) {
    setCurrentIndex(index);
    setLightboxOpen(true);
  }

  return (
    <div className="bg-[#090a0f] text-slate-100 min-h-screen pb-20">
      <Helmet>
        <title>Fotoarkiv - Foreningen ØrBike</title>
        <meta
          name="description"
          content="Gense de uforglemmelige øjeblikke fra ØrBike. Billeder fra 2024, 2025 og 2026 leveres i samarbejde med fotograf DreamFour."
        />
        <meta property="og:title" content="Fotoarkiv - Foreningen ØrBike" />
        <meta property="og:description" content="Se billederne fra Danmarks største indendørs spinning event gennem årene taget af DreamFour." />
      </Helmet>

      {/* Hero Header */}
      <section className="relative pt-36 sm:pt-40 pb-16 sm:pb-20 bg-gradient-to-b from-[#181224] to-[#090a0f] border-b border-pink-500/20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-400 border border-pink-500/30 mb-4">
            Minder & Fællesskab
          </span>
          <h1 className="text-4xl sm:text-6xl font-black font-display text-white uppercase tracking-tight">
            Fotoarkiv
          </h1>
          <p className="text-pink-300 font-display text-lg sm:text-2xl font-bold uppercase mt-2">
            Gense stemningen, sveden og smilene gennem årene
          </p>
        </div>
      </section>

      <section className="py-12 max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        {/* Fotograf Partner Henvisning for 2024, 2025 og 2026 */}
        <div className="p-6 sm:p-8 rounded-3xl bg-gradient-to-r from-purple-950/40 via-[#141526] to-pink-950/40 border border-pink-500/30 flex flex-col sm:flex-row items-center justify-between gap-6 shadow-xl">
          <div className="flex items-center gap-4 text-center sm:text-left">
            <div className="w-14 h-14 rounded-2xl bg-pink-500/20 border border-pink-500/40 text-pink-400 flex items-center justify-center text-2xl shrink-0">
              <i className="fa-solid fa-camera-retro" aria-hidden="true"></i>
            </div>
            <div>
              <span className="text-xs font-mono font-bold uppercase text-pink-400">
                Officiel Samarbejdspartner & Fotograf
              </span>
              <h3 className="text-xl sm:text-2xl font-black text-white font-display uppercase tracking-wide">
                Billeder leveret af DreamFour
              </h3>
              <p className="text-xs sm:text-sm text-slate-300 mt-1 max-w-2xl">
                For <strong>2024</strong>, <strong>2025</strong> og det kommende <strong>2026</strong> event henviser vi stolt til vores samarbejdspartner <strong>DreamFour</strong>, som er den officielle fotograf bag de mange uforglemmelige pletskud.
              </p>
            </div>
          </div>
          <div className="shrink-0 flex items-center gap-2 px-4 py-2 rounded-xl bg-pink-500/10 border border-pink-500/30 text-pink-300 text-xs font-bold uppercase tracking-wider">
            <i className="fa-solid fa-star text-pink-400" aria-hidden="true"></i>
            <span>DreamFour</span>
          </div>
        </div>

        {/* Årstals vælger (Dropdown menu under 992px) */}
        <div className="min-[992px]:hidden w-full sm:max-w-xs">
          <label htmlFor="foto-aar-select" className="block text-xs uppercase font-bold text-slate-400 font-mono mb-2">
            Vælg foto år:
          </label>
          <div className="relative">
            <select
              id="foto-aar-select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="w-full bg-slate-900 border border-slate-800 focus:border-pink-500 text-white font-bold font-display uppercase tracking-wider text-sm px-4 py-3 rounded-xl appearance-none shadow-lg focus:outline-none focus:ring-2 focus:ring-pink-500/30 transition-all cursor-pointer"
            >
              {aargange.map((year) => (
                <option key={year} value={year} className="bg-slate-900 text-white py-2">
                  Årgang {year} {year === "2026" ? "(Kommende event)" : year === "2025" ? "★ Seneste" : ""}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-pink-400">
              <i className="fa-solid fa-chevron-down text-sm" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        {/* Årstals vælger (Knapper fra 992px og op) */}
        <div className="hidden min-[992px]:flex items-center gap-2 overflow-x-auto pb-2 scrollbar-none">
          <span className="text-xs uppercase font-bold text-slate-400 font-mono shrink-0 mr-2">
            Foto år:
          </span>
          {aargange.map((year) => (
            <button
              key={year}
              onClick={() => setSelectedYear(year)}
              className={`px-4 py-2 rounded-xl text-xs font-bold font-display uppercase tracking-wider transition-all shrink-0 ${
                selectedYear === year
                  ? "bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-[0_0_15px_rgba(255,42,141,0.4)]"
                  : "bg-slate-900 border border-slate-800 text-slate-300 hover:border-pink-500/40 hover:text-white"
              }`}
            >
              {year} {year === '2026' ? '(Kommende)' : ''}
            </button>
          ))}
        </div>

        {/* 2026 Teaser (Når 2026 er valgt) */}
        {selectedYear === '2026' ? (
          <div className="p-12 rounded-3xl bg-[#12141f] border border-pink-500/30 text-center space-y-4 shadow-xl max-w-3xl mx-auto">
            <div className="w-16 h-16 rounded-full bg-pink-500/20 text-pink-400 flex items-center justify-center text-3xl mx-auto border border-pink-500/30">
              <i className="fa-solid fa-calendar-check" aria-hidden="true"></i>
            </div>
            <h3 className="text-2xl sm:text-3xl font-black text-white font-display uppercase">
              ØrBike 2026 – Lørdag den 14. november 2026
            </h3>
            <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
              Billederne fra det kommende ØrBike 2026 event vil blive taget af vores officielle samarbejdspartner og fotograf <strong>DreamFour</strong> og offentliggjort her på siden umiddelbart efter eventet.
            </p>
            <div className="pt-2">
              <span className="inline-block px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-pink-500/20 text-pink-300 border border-pink-500/40">
                Fotograf: DreamFour
              </span>
            </div>
          </div>
        ) : (
          <>
            {/* Billed Galleri Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 sm:gap-6">
              {billeder.map((src, index) => (
                <div
                  key={index}
                  onClick={() => openImage(index)}
                  className="group relative rounded-2xl overflow-hidden aspect-[4/3] bg-slate-900 border border-slate-800 hover:border-pink-500/60 cursor-pointer transition-all duration-300 hover:scale-[1.02] shadow-lg"
                >
                  <img
                    src={src}
                    alt={`ØrBike ${selectedYear} foto ${index + 1} - Fotograf: ${erDreamFourAar ? 'DreamFour' : 'ØrBike'}`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between p-3">
                    <span className="text-[11px] font-semibold text-white uppercase flex items-center gap-1">
                      <i className="fa-solid fa-expand text-pink-400" aria-hidden="true"></i>
                      <span>Vis stort</span>
                    </span>
                    <span className="w-8 h-8 rounded-full bg-pink-500 text-white flex items-center justify-center text-xs shadow">
                      <i className="fa-solid fa-camera" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Facebook Albums Link */}
        <div className="p-8 rounded-3xl bg-gradient-to-r from-pink-950/40 via-purple-950/30 to-slate-900 border border-pink-500/30 text-center space-y-3">
          <span className="text-xs uppercase font-mono font-bold text-pink-400">Find endnu flere fotos</span>
          <h3 className="text-2xl sm:text-3xl font-black text-white font-display uppercase">
            Officielle Facebook Fotoalbum
          </h3>
          <p className="text-slate-300 text-xs sm:text-sm max-w-xl mx-auto">
            Hvert år udgiver vi hundredevis af billeder taget af vores dygtige eventfotografer på ØrBikes officielle Facebook side.
          </p>
          <div className="pt-2">
            <a
              href="https://www.facebook.com/Orbike/photos_albums"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-xs uppercase tracking-wider shadow-lg hover:scale-105 transition-transform"
            >
              <i className="fa-brands fa-facebook" aria-hidden="true"></i>
              <span>Åbn Facebook Fotoalbum</span>
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {billeder.length > 0 && (
        <Lightbox
          images={billeder}
          currentIndex={currentIndex}
          isOpen={lightboxOpen}
          onClose={() => setLightboxOpen(false)}
          onPrev={() => setCurrentIndex((prev) => (prev > 0 ? prev - 1 : billeder.length - 1))}
          onNext={() => setCurrentIndex((prev) => (prev < billeder.length - 1 ? prev + 1 : 0))}
        />
      )}
    </div>
  );
}
